export default "/_next/static/images/star-eebe8017b19b11a24937c5e64e1b68f5.svg";